<p-autoComplete
    [(ngModel)]="selectedItem"
    [dropdown]="true"
    [suggestions]="filteredItems"
    (completeMethod)="filterItems($event)"
    (onSelect)="onSelectItem($event)"
    optionLabel="name"
    [disabled]="field?.disabled"
    showClear="true"
    (onClear)="onClear()" 
    [placeholder]="placeholder" />